module.exports = __webpack_public_path__ + "static/blue1-6a304887c7e668f8f6d23de9c988ba32.png";